const USER_KEY = "legal_portal_user";
const NOTICE_KEY = "legal_portal_session_notice";

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    localStorage.removeItem(USER_KEY);
    return null;
  }
}

export function storeUser(user) {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export function clearStoredUser() {
  localStorage.removeItem(USER_KEY);
}

export function setSessionNotice(message) {
  sessionStorage.setItem(NOTICE_KEY, message);
}

export function consumeSessionNotice() {
  const message = sessionStorage.getItem(NOTICE_KEY) || "";
  sessionStorage.removeItem(NOTICE_KEY);
  return message;
}

export function homeForRole(role, user = null) {
  if (user?.is_demo && user?.demo_mfa_exempt) return "/app/demo";
  if (role === "platform_admin") return "/platform/registrations";
  if (["facility_admin", "admin"].includes(role)) return "/admin";
  if (role === "attorney") return "/attorney/documents";
  if (role === "inmate") return "/inmate/documents";
  return "/login";
}
